// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__jXhh8","blue":"style_blue__vfBaY","modal":"style_modal__La6Nj","right":"style_right__PWUOP"};